import React, { useEffect, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'

// Convert UTC string -> {date, time} in user's local timezone
function utcToLocalParts(utcString) {
  if (!utcString) return { date: '', time: '' }
  const d = new Date(utcString)
  return {
    date: d.toLocaleDateString('en-CA'), // YYYY-MM-DD
    time: d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
  }
}

// Combine local date + time -> UTC ISO string
function localPartsToUtc(date, time) {
  if (!date || !time) return null
  return new Date(`${date}T${time}`).toISOString()
}

function CloseTimeComponent({ handleColumnChange, columnsValues, validationResults }) {
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')

  // Whenever columnsValues['close_time'] changes -> sync local state
  useEffect(() => {
    if (columnsValues['close_time']) {
      const { date, time } = utcToLocalParts(columnsValues['close_time'])
      setDate(date)
      setTime(time)
    } else {
      setDate('')
      setTime('')
    }
  }, [columnsValues['close_time']])

  const handleDateChange = e => {
    const newDate = e.target.value
    setDate(newDate)
    const utc = localPartsToUtc(newDate, time)
    if (utc) handleColumnChange({ target: { value: utc } }, { name: 'close_time' })
  }

  const handleTimeChange = e => {
    const newTime = e.target.value
    setTime(newTime)
    const utc = localPartsToUtc(date, newTime)
    if (utc) handleColumnChange({ target: { value: utc } }, { name: 'close_time' })
  }

  return (
    <Row className="g-2 align-items-center">
      <Col xs="3">
        <h6>Close Time (Local)</h6>
      </Col>
      <Col xs="5">
        <Form.Control type="date" value={date} onChange={handleDateChange} isInvalid={validationResults['close_time'] === false} />
      </Col>
      <Col xs="4">
        <Form.Control type="time" value={time} onChange={handleTimeChange} isInvalid={validationResults['close_time'] === false} />
      </Col>
    </Row>
  )
}

export default CloseTimeComponent
